import * as z from "zod/v4";

export const getLinearCommentCounts = {
  name: "getLinearCommentCounts" as const,
  input: z.object({ linearTicketIds: z.array(z.string()) }),
  output: z.object({ counts: z.record(z.string(), z.number()) }),
};
